import React, {useState} from 'react';
import {Grid, TextField} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import {Controller, useFormContext} from 'react-hook-form';
import {
    FormControl,
    FormLabel,
    RadioGroup as MRadioGroup,
    Radio,
    FormControlLabel,
    FormHelperText,
} from '@material-ui/core';
import get from 'lodash.get';
import {optionsObjectToArray} from './optionsHelper';

const useStyles = makeStyles(theme => ({
    radio: {
        marginRight: '3em',
    },
}));

function RadioGroupWithWritein({name, label, row, options, required, autocomplete}) {
    const {control, errors} = useFormContext();
    const classes = useStyles();
    const error = get(errors, name);

    const [selectedValue, setSelectedValue] = useState('');
    const [writeInOption, setWriteInOption] = useState(
        selectedValue in options ? null : selectedValue
    );

    const handleRadioChange = event => {
        setSelectedValue(event.target.value);
    };

    const handleWriteInOptionChange = event => {
        setWriteInOption(event.target.value);
        handleRadioChange(event);
    };

    return (
        <FormControl fullWidth component='fieldset' error={!!error}>
            <FormLabel required={required} component='legend'>
                {label}
            </FormLabel>
            <Controller
                render={({onChange, onBlur, value}) => {
                    value = selectedValue;

                    return (
                        <MRadioGroup
                            aria-label={label}
                            row={row}
                            value={selectedValue}
                            onChange={e => {
                                handleRadioChange(e);
                                onChange(e);
                            }}
                            onBlur={onBlur}
                        >
                            <Grid container direction={row ? 'row' : 'column'}>
                                {optionsObjectToArray(options).map(option => (
                                    <Grid
                                        item
                                        className={classes.radio}
                                        key={option.value}
                                    >
                                        <FormControlLabel
                                            labelPlacement='end'
                                            value={option.value}
                                            control={
                                                <Radio
                                                    data-cy={`form-field-${name}-${option.value}`}
                                                />
                                            }
                                            label={option.label}
                                        />
                                    </Grid>
                                ))}
                                <Grid
                                    item
                                    className={classes.radio}
                                    key='other'
                                >
                                    <FormControlLabel
                                        labelPlacement='end'
                                        value={writeInOption}
                                        control={
                                            <Radio
                                                data-cy={`form-field-${name}-writein}`}
                                            />
                                        }
                                        label={
                                            <TextField
                                                label='Other'
                                                onChange={e => {
                                                    handleWriteInOptionChange(
                                                        e
                                                    );
                                                    onChange(e);
                                                }}
                                                inputProps={{
                                                    autocomplete,
                                                }}
                                            />
                                        }
                                    />
                                </Grid>
                            </Grid>
                        </MRadioGroup>
                    );
                }}
                name={name}
                control={control}
            />
            <FormHelperText>{error?.message}</FormHelperText>
        </FormControl>
    );
}

export default RadioGroupWithWritein;
